module.exports = __webpack_public_path__ + "img/vehicle-slides-backdrop-honda.4734dba5.png";